import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'Check',
  standalone: true,
})
export class CheckPipe implements PipeTransform {
  public transform(value: string, query: string[], item: any): boolean {
    const toArray = query[value] && query[value].split(',');
    return (item?.code.includes('all_') && !toArray) || (!!toArray && toArray.includes(item?.code));
  }
}
